
const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Fetch products from the API
 * @param {string} search - Search query
 * @returns {Promise<{products: Array, total: number, page: number, per_page: number}>}
 */
export const fetchProducts = async (page = 1, perPage = 20, search = '') => {
    try {
        let url = `${BASE_URL}/products?page=${page}&per_page=${perPage}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Error fetching products: ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to fetch products:", error);
        throw error;
    }
};

/**
 * Fetch random products using shuffle API
 * @param {number} count - Number of random products to fetch (max 100)
 * @returns {Promise<{products: Array, count: number}>}
 */
export const shuffleProducts = async (count = 10) => {
    try {
        const url = `${BASE_URL}/products/shuffle?count=${Math.min(count, 100)}`;
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Error shuffling products: ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to shuffle products:", error);
        throw error;
    }
};

/**
 * Generate XML Feed
 * @returns {Promise<{message: string, path: string}>}
 */
export const generateFeed = async () => {
    try {
        const response = await fetch(`${BASE_URL}/feed/generate`, {
            method: 'POST',
        });
        if (!response.ok) {
            throw new Error(`Error generating feed: ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Failed to generate feed:", error);
        throw error;
    }
};

/**
 * Process Batch of Products with Template
 * @param {Array} products - List of products to process
 * @param {Object} templateData - Polotno JSON template
 * @returns {Promise<{message: string, count: number}>}
 */
export const processBatch = async (products, templateData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_2}/api/process-batch`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                products: products,
                template: templateData
            }),
        });
        if (!response.ok) {
            throw new Error(`Error processing batch: ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Failed to process batch:", error);
        throw error;
    }
};

/**
 * Fetch Enriched Products
 * @returns {Promise<Array>}
 */
export const fetchEnrichedProducts = async () => {
    try {
    
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_2}/api/enrichments`);
        if (!response.ok) {
            throw new Error(`Error fetching enrichments: ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Failed to fetch enrichments:", error);
        throw error;
    }
};

